import {Pipe, PipeTransform} from '@angular/core';
import {VenueDTO} from '@domain/venue/venue.dto';

@Pipe({
  name: 'venue',
  pure: true
})
export class VenuePipe implements PipeTransform {

  public transform(
    venue: VenueDTO | null | undefined,
    options: {
      showName?: boolean;
      showAddress?: boolean;
    } = {}
  ): string | null {
    return VenuePipe.formatAddress(venue, options);
  }

  private static formatAddress(
    venue: VenueDTO | null | undefined,
    options: {
      showName?: boolean;
      showAddress?: boolean;
    } = {}
  ): string | null {
    if (!venue) {
      return null;
    }
    const showName = options.showName ?? false;
    const showAddress = options.showAddress ?? true;
    let str = showName && venue?.name ? `${venue.name} - ` : '';
    if (showAddress && venue?.address) {
      str += venue?.address;
    }
    const postalCode = venue?.postalCode ?? null;
    const locality = venue?.locality ?? null;
    if (!(postalCode || locality)) {
      return str;
    }
    if (str.length > 0) {
      str += ', ';
    }
    return `${str}${postalCode ?? ''} ${locality}`;
  }

}
